module.exports = __webpack_public_path__ + "static/media/7.056040b0.svg";